import Crud from '../views/Documento/Crud'
import Add from '../views/Documento/Add'
import Detalhe from '../views/Documento/Detalhe'

let routes = {
    path: '/documentos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/documentos/add',
            name: 'NewDocumento',
            component: Add,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    { text: 'Documentos', to: '/documentos' },
                    { text: 'Enviar', active: true },
                ],
            },
        },
        {
            path: '/documentos/view/:id',
            name: 'ViewDocumento',
            component: Detalhe,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    { text: 'Documentos', to: '/documentos' },
                    { text: 'Detalhe', active: true },
                ],
            },
        },
        {
            path: '/documentos',
            name: 'list-documentos',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Documentos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
